import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import propTypes from "prop-types";

const WithModal = Component => {
  class ComponentWithModal extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isModalOpen: false,
      };
    }
    openModal = () => {
      if (this.props.disable) alert(this.props.message);
      else {
        this.setState({ isModalOpen: true });
        const functions = this.props.onOpenFunctions;
        functions && functions.forEach(func => func());
      }
    };

    closeModal = () => {
      const functions = this.props.onCloseFunctions;
      this.setState({ isModalOpen: false });
      functions && functions.forEach(func => func());
    };

    render() {
      const { Trigger } = this.props;
      if (!Trigger)
        throw new Error(
          "Trigger element is required. Create a Trigger component and pass it as a prop to the component that is to be converted as a modal.",
        );
      return (
        <>
          {/* The UI for the modal trigger is plugged here */}
          <div onClick={this.openModal}>{Trigger && <Trigger />}</div>

          {/* Modal Code */}
          <Transition appear show={this.state.isModalOpen} as={React.Fragment}>
            <Dialog
              as="div"
              className="fixed inset-0 z-50 overflow-y-auto"
              onClose={this.closeModal}>
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={React.Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0">
                  <Dialog.Overlay
                    className={`fixed inset-0 bg-black ${
                      this.state.isModalOpen ? "opacity-75" : "opacity-0"
                    }`}
                  />
                </Transition.Child>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span
                  className="inline-block h-screen align-middle"
                  aria-hidden="true">
                  &#8203;
                </span>
                <Transition.Child
                  as={React.Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95">
                  <div className="inline-block overflow-visible rounded-2xl text-left align-middle transition-all transform bg-white ">
                    {/* The component wrapped with WithModal HOC */}
                    <Component {...this.props} closeModal={this.closeModal} />
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>
        </>
      );
    }
  }

  ComponentWithModal.propTypes = {
    Trigger: propTypes.func.isRequired,
    onOpenFunctions: propTypes.array,
    onCloseFunctions: propTypes.array,
    disable: propTypes.bool,
    message: propTypes.string,
  };

  return ComponentWithModal;
};

WithModal.propTypes = {
  Component: propTypes.elementType,
};

export default WithModal;
